import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgDistrict extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg viewBox="0 0 254.28 196.58" height={size}>
                <polygon points="0 99.68 97.93 99.68 48.97 56.33 0 99.68" fill={color} />
                <path
                    d="M23.72,190.39v96.53h98V190.39Zm42.56,58.28H51.66V234.05H66.28Zm0-26H51.66V208.06H66.28Zm27.52,26H79.19V234.05H93.8Zm0-26H79.19V208.06H93.8Z"
                    transform="translate(-23.72 -90.71)"
                    fill={color}
                />
                <rect x="75.73" y="62.95" width="11" height="36.21" fill={color} />
                <path
                    d="M156.74,195.82c0,11.77-5.15,21.32-11.51,21.32s-11.52-9.55-11.52-21.32,5.16-21.31,11.52-21.31S156.74,184.05,156.74,195.82Z"
                    transform="translate(-23.72 -90.71)"
                    fill={color}
                />
                <path
                    d="M142,211.68c0,8.08-5,14.63-11.26,14.63s-11.25-6.55-11.25-14.63,5-14.63,11.25-14.63S142,203.6,142,211.68Z"
                    transform="translate(-23.72 -90.71)"
                    fill={color}
                />
                <path
                    d="M162.81,214.1c0,6.74-4.15,12.21-9.27,12.21s-9.27-5.47-9.27-12.21,4.15-12.21,9.27-12.21S162.81,207.36,162.81,214.1Z"
                    transform="translate(-23.72 -90.71)"
                    fill={color}
                />
                <path
                    d="M152.41,238.5c0,9.05-5.42,16.4-12.12,16.4s-12.12-7.35-12.12-16.4,5.42-16.4,12.12-16.4S152.41,229.44,152.41,238.5Z"
                    transform="translate(-23.72 -90.71)"
                    fill={color}
                />
                <path
                    d="M149.73,224.44c0,4.91-4.25,8.9-9.48,8.9s-9.49-4-9.49-8.9,4.25-8.91,9.49-8.91S149.73,219.52,149.73,224.44Z"
                    transform="translate(-23.72 -90.71)"
                    fill={color}
                />
                <path
                    d="M134.14,230.53c0,4.45-2.67,8.06-6,8.06s-6-3.61-6-8.06,2.67-8.07,6-8.07S134.14,226.07,134.14,230.53Z"
                    transform="translate(-23.72 -90.71)"
                    fill={color}
                />
                <path
                    d="M163,228.28c0,7-4.23,12.74-9.44,12.74s-9.44-5.71-9.44-12.74,4.23-12.75,9.44-12.75S163,221.24,163,228.28Z"
                    transform="translate(-23.72 -90.71)"
                    fill={color}
                />
                <path
                    d="M139.68,197.05c0,4.45-2.67,8.06-6,8.06s-6-3.61-6-8.06,2.68-8.07,6-8.07S139.68,192.59,139.68,197.05Z"
                    transform="translate(-23.72 -90.71)"
                    fill={color}
                />
                <ellipse cx="131.98" cy="111.19" rx="5.98" ry="8.07" fill={color} />
                <path
                    d="M156.48,241c0,4.46-2.67,8.07-6,8.07s-6-3.61-6-8.07,2.68-8.07,6-8.07S156.48,236.56,156.48,241Z"
                    transform="translate(-23.72 -90.71)"
                    fill={color}
                />
                <rect x="117.26" y="142.24" width="3.55" height="54.33" fill={color} />
                <path
                    d="M278,145.07,216.54,90.71l-61.42,54.36h-.05V286.48H278V145.07ZM208.11,249.42H193.49V234.81h14.62Zm0-26H193.49V208.79h14.62Zm0-26H193.49V182.79h14.62Zm27.52,52H221V234.81h14.61Zm0-26H221V208.79h14.62Zm0-26H221V182.79h14.62Z"
                    transform="translate(-23.72 -90.71)"
                    fill={color}
                />
            </svg>
        );
    }
}

export default withTheme(SvgDistrict);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgDistrict.js